import http from '@/shared/api/http'

export async function getValues(attributeId) {
  const response = await http.get(`/attributes/${attributeId}/values`)
  return response.data
}

export async function createValue(attributeId, value) {
  const response = await http.post(`/attributes/${attributeId}/values`, { Value: value })
  return response.data
}

export async function updateValue(attributeId, id, value) {
  const response = await http.put(`/attributes/${attributeId}/values/${id}`, { Value: value })
  return response.data
}

export async function deleteValue(attributeId, id) {
  const response = await http.delete(`/attributes/${attributeId}/values/${id}`)
  return response.data
}